import * as Yup from "yup";

const campoNumerico = (label) =>
  Yup.number()
    .transform((valor, original) => (original === "" ? undefined : valor))
    .typeError(label);

const desdobrarTituloValidator = Yup.object().shape({
  tipoDesdobramento: Yup.string().required("Tipo de Desdobramento"),
  tipoVencimento: Yup.string().required("Vencimento das Parcelas"),
  qtdParcelas: campoNumerico("Quantidade de Parcelas")
    .min(2, "Quantidade de Parcelas")
    .required("Quantidade de Parcelas"),
  intervaloDias: Yup.number().when("tipoVencimento", {
    is: "DIA_FIXO",
    then: Yup.number().notRequired(),
    otherwise: campoNumerico("Intervalo de Dias")
      .min(1, "Intervalo de Dias")
      .required("Intervalo de Dias"),
  }),
  diaVencimento: Yup.number().when("tipoVencimento", {
    is: "DIA_FIXO",
    then: campoNumerico("Dia do Vencimento")
      .min(1, "Dia do Vencimento")
      .max(31, "Dia do Vencimento")
      .required("Dia do Vencimento"),
    otherwise: Yup.number().notRequired(),
  }),
});

export default desdobrarTituloValidator;
